// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"65ff4531","308":"29d3b2a7","511":"58c61660"}[chunkId] + ".chunk.js";
};